module.exports = __webpack_public_path__ + "static/media/AboutPage__Wanikei.707960af.png";